export default "<h3>{{ 'notfound.title' | translate }}</h3>\n<p>{{ 'notfound.desc' | translate }}</p>\n"